"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDataToVisualize = void 0;
var _cccisdApollo = require("cccisd-apollo");
var _frequencyData = _interopRequireDefault(require("./frequencyData.graphql"));
var _crosstabData = _interopRequireDefault(require("./crosstabData.graphql"));
var _groupData = _interopRequireDefault(require("./groupData.graphql"));
var _overtimeData = _interopRequireDefault(require("./overtimeData.graphql"));
var _getCombinedFilter = _interopRequireDefault(require("./getCombinedFilter.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function getFormattedFilter(filter) {
  function traverse(node) {
    if (!node) {
      return {};
    }
    var hasConditions = node.aggregation && node.conditions.filter(function (item) {
      return item.column;
    }).length > 0;
    if (node.aggregation === 'all' && hasConditions) {
      return {
        AND: node.conditions.map(traverse)
      };
    }
    if (node.aggregation === 'any' && hasConditions) {
      return {
        OR: node.conditions.map(traverse)
      };
    }
    if (node.column) {
      return _defineProperty({}, node.operator, {
        field: "pawn.".concat(node.column.id),
        "int": node.column.type === 'number' ? node.value : undefined,
        string: node.column.type === 'string' ? node.value : undefined,
        "boolean": node.column.type === 'boolean' ? node.value : undefined
      });
    }
    return '';
  }
  return traverse(filter);
}
var getDataToVisualize = exports.getDataToVisualize = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(params) {
    var assignmentId, deploymentIds, metric, metricSettings, querySettings, tableFilters, tableSelectedRows, applyPawnContext, includeIdentifiable, combinedFilter, res, _res, _res2, _res3;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          assignmentId = params.assignmentId, deploymentIds = params.deploymentIds, metric = params.metric, metricSettings = params.metricSettings, querySettings = params.querySettings, tableFilters = params.tableFilters, tableSelectedRows = params.tableSelectedRows, applyPawnContext = params.applyPawnContext, includeIdentifiable = params.includeIdentifiable;
          combinedFilter = function () {
            if (tableSelectedRows.length > 0) {
              return {
                "in": {
                  field: 'assignmentProgressId',
                  string: tableSelectedRows.map(function (id) {
                    return "".concat(id);
                  })
                }
              };
            }
            var result = (0, _getCombinedFilter["default"])(getFormattedFilter(querySettings.filter), tableFilters);

            // replace variables with codedVariables for all instances
            return JSON.parse(JSON.stringify(result).replace(/"variables\./g, '"codedVariables.'));
          }();
          if (!(metricSettings.comparison === 'none')) {
            _context.n = 2;
            break;
          }
          _context.n = 1;
          return _cccisdApollo.client.query({
            query: _frequencyData["default"],
            fetchPolicy: 'network-only',
            variables: {
              field: "codedVariables.".concat(metric.reportHeader),
              deploymentIds: deploymentIds,
              assignmentId: assignmentId,
              filter: combinedFilter,
              applyPawnContext: applyPawnContext,
              includeIdentifiable: Boolean(includeIdentifiable)
            },
            cancelTag: 'viz'
          });
        case 1:
          res = _context.v;
          return _context.a(2, res.data.flows.assignmentProgressSummary);
        case 2:
          if (!(metricSettings.comparison === 'crosstab' && metricSettings.compareWith)) {
            _context.n = 4;
            break;
          }
          _context.n = 3;
          return _cccisdApollo.client.query({
            query: _crosstabData["default"],
            fetchPolicy: 'network-only',
            variables: {
              assignmentId: assignmentId,
              deploymentIds: deploymentIds,
              field1: "variables.".concat(metric.reportHeader),
              field2: metricSettings.compareWith,
              filter: combinedFilter,
              applyPawnContext: applyPawnContext
            },
            cancelTag: 'viz'
          });
        case 3:
          _res = _context.v;
          return _context.a(2, _res.data.flows.assignmentProgressSummary);
        case 4:
          if (!(metricSettings.comparison === 'grouptype' && metricSettings.compareByGroupType)) {
            _context.n = 6;
            break;
          }
          _context.n = 5;
          return _cccisdApollo.client.query({
            query: _groupData["default"],
            fetchPolicy: 'network-only',
            variables: {
              assignmentId: assignmentId,
              deploymentIds: deploymentIds,
              field1: "variables.".concat(metric.reportHeader),
              filter: combinedFilter,
              groupType: metricSettings.compareByGroupType
            },
            cancelTag: 'viz'
          });
        case 5:
          _res2 = _context.v;
          return _context.a(2, _res2.data.flows.assignmentProgressSummary);
        case 6:
          if (!(metricSettings.comparison === 'overtime')) {
            _context.n = 8;
            break;
          }
          _context.n = 7;
          return _cccisdApollo.client.query({
            query: _overtimeData["default"],
            fetchPolicy: 'network-only',
            variables: {
              assignmentId: assignmentId,
              deploymentIds: deploymentIds,
              field1: "variables.".concat(metric.reportHeader),
              filter: combinedFilter,
              applyPawnContext: applyPawnContext
            },
            cancelTag: 'viz'
          });
        case 7:
          _res3 = _context.v;
          return _context.a(2, _res3.data.flows.assignmentProgressSummary);
        case 8:
          return _context.a(2);
      }
    }, _callee);
  }));
  return function getDataToVisualize(_x) {
    return _ref2.apply(this, arguments);
  };
}();